import script from "./Panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./Panel.vue?vue&type=script&setup=true&lang=ts"

import "./Panel.vue?vue&type=style&index=0&id=d61e4b1e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d61e4b1e"]])

export default __exports__